import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { InboxService, MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-am-header-inbox',
    templateUrl: 'header-inbox.html',
})
export class HeaderInboxComponent extends AccountMenuItemBase implements OnInit, OnDestroy {
    private inboxService = inject(InboxService);

    newMessagesCount: number = 0;
    newMessagesText: string;

    private unsubscribe = new Subject<void>();

    ngOnInit() {
        this.inboxService.whenReady.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.inboxService.count.pipe(takeUntil(this.unsubscribe)).subscribe((count: number) => {
                this.newMessagesCount = count || 0;
                this.newMessagesText = this.item.resources['NewMessagesText']!.replace('_COUNT_', this.newMessagesCount.toString());
            });
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
